export const UserActionTypes = {
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  SET_CURRENT_USER_JWT: 'SET_CURRENT_USER_JWT',
  REMOVE_CURRENT_USER: 'REMOVE_CURRENT_USER',
}
